import { ErrorMessage, FormikHandlers, FormikValues } from 'formik';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import CheckboxInput from 'src/components/UI/CheckboxInput';
import ErrorText from 'src/components/UI/ErrorText';
import { ConvertIsoStringWithTime, formatDateTimeFormServerView, formatUtcNewForEditWithTime, hasAdminOrEmployeeRoleHandler, hasCustomerRoleHandler, hasDealerRoleHandler, hasDealerSubuserRoleHandler, hasFranchiseRoleHandler, hasFranchiseSubuserRoleHandler } from 'src/helpers/common_helpers';
import { CHECK_VALUE_IN_ARRAY } from 'src/helpers/jobsheet_validation';
import { clearFaultySystem, updateFaultySystemLoading, updateNeedReversePickupLoading, updateIncomingDispatchTrackingLoading } from 'src/store/actions';
import FeatherIcon from "feather-icons-react";
import { RootReducerState } from 'src/store/reducers';
import StatusHghlighter from 'src/components/Common/StatusHighlighter/StatusHighlighter';

interface FaultySystemProps {
  values: FormikValues;
  handleChange: FormikHandlers['handleChange'];
  handleBlur: FormikHandlers['handleBlur'];
  id: any;
  validationConfiguration?: any;
  rest: any; // Can be more specific if needed (e.g., Input props)
  disabledForDealer: any[];
  setFieldValue: any;
  isJobView?: boolean;
  jobStatus?: any[];
  isExchange: boolean;
}

const ReversePickupDialogContent = ({ onChange }: { onChange: (val: boolean) => void }) => {
  const [checked, setChecked] = useState<any>(false);
  return (
    <div>
      <p>Are you sure you want to change <strong>Replaced</strong>?</p>
      <CheckboxInput
        name="isReversePickup"
        label="Do you need reverse pickup"
        value={checked}
        onChange={(e: any) => {
          setChecked(e.checked);
          onChange(e.checked);
        }}
      />
    </div>
  );
};

const FaultySystem = ({ values, handleChange, id, validationConfiguration, handleBlur, rest, disabledForDealer, setFieldValue, isJobView = false, jobStatus = [], isExchange }: FaultySystemProps) => {
  const { faultySystemResponse, defectivePartsData } = useSelector((state: RootReducerState) => state.jobsheetReducer);
  const [scanParts, setScanParts] = useState([])
  const hasAccess = (data: any) => {
    if (data.userType == "Employee" && hasAdminOrEmployeeRoleHandler()) {
      return true
    } else if ((data.userType == "Franchise" || data.userType == "FranchiseSubUser") && (hasFranchiseRoleHandler() || hasFranchiseSubuserRoleHandler())) {
      return true
    } else if ((data.userType == "Dealer" || data.userType == "DealerSubUser") && (hasDealerRoleHandler() || hasDealerSubuserRoleHandler())) {
      return true
    } else {
      return false
    }
  }
  useEffect(() => {
    let filteredData = defectivePartsData?.length > 0 ? defectivePartsData?.filter((data: any) => data.isDeleted != true && data.id != 0 && hasAccess(data)) : []
    setScanParts(filteredData)
  }, [defectivePartsData])

  const isFranchiseUser = hasFranchiseRoleHandler() || hasFranchiseSubuserRoleHandler();
  console.log("faultySystemResponse", values.faultySystemAvailableList)
  const newDateRef = useRef<Date | null>(null);
  const [, forceUpdate] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    if (faultySystemResponse?.length > 0) {
      faultySystemResponse?.forEach((faultySystem: any, index: any) => {
        setFieldValue(`faultySystemAvailableList[${index}].isFaultySystem`, faultySystem.isFaultySystem ? true : false)
        setFieldValue(`faultySystemAvailableList[${index}].isSendFromMel`, faultySystem.isSendFromMel ? true : false)
        setFieldValue(`faultySystemAvailableList[${index}].isDelivered`, faultySystem.isDelivered ? true : false)
        setFieldValue(`faultySystemAvailableList[${index}].isReplace`, faultySystem.isReplace ? true : false)
        setFieldValue(`faultySystemAvailableList[${index}].partReplacedDate`, faultySystem.partReplacedDate ? formatUtcNewForEditWithTime(faultySystem.partReplacedDate) : "")
        setFieldValue(`faultySystemAvailableList[${index}].partSentFromMelDate`, faultySystem.partSentFromMelDate ? formatUtcNewForEditWithTime(faultySystem.partSentFromMelDate) : "")
        setFieldValue(`faultySystemAvailableList[${index}].partDeliveredDate`, faultySystem.partDeliveredDate ? formatUtcNewForEditWithTime(faultySystem.partDeliveredDate) : "")
      })
      dispatch(clearFaultySystem())
    }
  }, [faultySystemResponse])

  const statusBodyTemplate = (value: boolean) => {
    if (value) {
      return <div className="yes-template">YES</div>;
    } else {
      return <div className="no-template">NO</div>;
    }
  };

  const reversePickupCourier = ["Blue Dart", "Blue Dart eCOM", "DPWORLD"]
  const [reversePickup, setReversePickup] = useState(false)

  return (<Row>
    <Col lg={6} md={6} className="mb-2 mt-3 align-items-center">
      <b className="header mb-2">Outgoing Courier Tracking</b>
      <div className="card ps-0 pe-0 " id="table-border">
        <DataTable
          value={values.faultySystemAvailableList}
          showGridlines
        //   style={{maxWidth:"800px"}}
        >
          <Column field="courierName" header="Courier" body={(rowData) => <b>{rowData.deliveryType == "Hand Carry" ? "Hand Carry" : (rowData.courierName == "Other" ? rowData.courierNameIndividual : rowData.courierName)}</b>} />
          <Column field="awbNumber" header="Way Bill No." body={(rowData) => <b>{rowData.awbNumber}</b>} />
          <Column field="label" header="Dispatch Number" />


          {[
            { field: 'isSendFromMel', label: 'Courier Pickup Done', isDate: false },
            { field: 'partSentFromMelDate', label: 'Courier Pickup Date', isDate: true, dependency: 'isSendFromMel' },
            { field: 'isDelivered', label: 'Delivered', isDate: false },
            { field: 'partDeliveredDate', label: 'Delivered Date', isDate: true, dependency: 'isDelivered' },
            // { field: 'isReplace', label: 'Replaced', isDate: false },
            // { field: 'partReplacedDate', label: 'Replaced Date', isDate: true, dependency: 'isReplace' },
            // { field: 'isFaultySystem', label: 'Faulty System Available', isDate: false },
          ].map(({ field, label, isDate, dependency }) => (
            <Column
              key={field}
              header={label}
              headerClassName="headerjobsheet"
              body={(rowData, options) => {
                const index = options.rowIndex;

                const {
                  isSendFromMel,
                  isDelivered,
                  isReplace,
                  isFaultySystem,
                } = rowData;

                const isDisabledByDependency =
                  (field === 'isDelivered' && (!isSendFromMel || isFranchiseUser)) ||
                  (field === 'isReplace' && !isDelivered) ||
                  (field === 'isFaultySystem' && (!isReplace || isFranchiseUser)) || (isJobView == true && jobStatus.includes(values.status));
                console.log("isDisabledByDependency", field, values.status)
                if (!isDate) {
                  return (
                    <div className='d-flex justify-content-center'>
                      <CheckboxInput
                        name={`faultySystemAvailableList[${index}].${field}`}
                        label=""
                        {...rest}
                        onChange={(e: any) => {
                          if (e.checked) {
                            if (field === 'isReplace' && reversePickupCourier?.includes(values?.faultySystemAvailableList[index]?.courierName)) {
                              let localReversePickup = false;
                              confirmDialog({
                                header: (
                                  <div>
                                    Confirmation {label}
                                  </div>
                                ),
                                message: (isExchange ? <ReversePickupDialogContent onChange={(val) => (localReversePickup = val)} /> : <p>Are you sure you want to change <strong>Replaced</strong>?</p>),
                                icon: 'pi pi-exclamation-triangle',
                                accept: () => {
                                  handleChange(e);
                                  setFieldValue('isAutoReversePickupTrue', localReversePickup)
                                  setFieldValue(`faultySystemAvailableList[${index}].isAutoReversePickup`, localReversePickup)
                                  dispatch(
                                    updateNeedReversePickupLoading(
                                      id,
                                      rowData.outgoingDispatchId,
                                      rowData.label,
                                      field,
                                      "",
                                      "",
                                      localReversePickup
                                    )
                                  );
                                },
                              });
                              return; // Do not proceed
                            }
                            confirmDialog({
                              header: `Confirmation ${label}`,
                              message: (
                                <div>
                                  <p>Are you sure you want to mark <strong>{rowData.awbNumber}</strong> as <strong>{label}</strong>?</p>
                                </div>
                              ),
                              icon: 'pi pi-exclamation-triangle',
                              acceptClassName: 'p-button-danger',
                              accept: () => {
                                handleChange(e);
                                dispatch(
                                  updateFaultySystemLoading(
                                    id,
                                    rowData.outgoingDispatchId,
                                    rowData.label,
                                    field
                                  )
                                );
                              },
                            });
                          } else {
                            handleChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                        value={rowData[field]}
                        required={false}
                        disabled={
                          rowData[field] || isDisabledByDependency || ((hasCustomerRoleHandler() || hasDealerRoleHandler()) ? disabledForDealer.includes(field) : false)
                        }
                      />
                      <ErrorMessage
                        name={`faultySystemAvailableList[${index}].${field}`}
                        component={ErrorText}
                      />
                    </div>
                  );
                } else {
                  const isEditable = (dependency ? rowData[dependency] : false) && !(isJobView == true && jobStatus.includes(values.status));
                  const dateValue = rowData[field] != ""
                    ? formatDateTimeFormServerView(rowData[field], false)
                    : 'N/A';

                  return (
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <span>{dateValue}</span>
                      {/* {isEditable && (
                      <div className='job-icon'><FeatherIcon icon={"edit-2"} 
                      onClick={
                        ()=>{
                          newDateRef.current = rowData[field] ? rowData[field] : null;
                           confirmDialog({
                            header: `Change ${label}`,
                            message: (
                              <div className=''>
                                <p>Are you sure you want to change the <strong>{label}</strong>?</p>
                                <div>
                                   <Calendar
                                               name={field}
                                               inputId={label}
                                               id={label}
                                               value={newDateRef.current}
                                               onChange={(e: any) => {
                                                  newDateRef.current = e.value;
                                                  forceUpdate((prev) => !prev); // Force re-render
                                                }}
                                               className={`p-inputfield `}
                                               disabled={false}
                                               showIcon={true}
                                               dateFormat="dd-mm-yy"
                                               hourFormat="24"
                                               showButtonBar
                                               clearButtonClassName="calendar_button"
                                               todayButtonClassName="calendar_button"
                                               // minDate = {today && new Date() }
                                             />
                                </div>
                              </div>
                            ),
                            icon: 'pi pi-exclamation-triangle',
                            acceptClassName: 'p-button-danger',
                            accept: () => {
                              // handleChange(e);
                              if(newDateRef.current){
                                dispatch(
                                  updateFaultySystemLoading(
                                    id,
                                    rowData.outgoingDispatchId,
                                    rowData.label,
                                    field,
                                    "",
                                    ConvertIsoStringWithTime(newDateRef.current)
                                  )
                                );
                              }
                            },
                          });
                        }
                      }
                      /></div>
                    )} */}
                    </div>
                  );
                }
              }}
            />
          ))}
          {/* <Column field="isAutoReversePickup" header="Reverse Pickup" body={(rowData) => <b>{statusBodyTemplate(rowData.isAutoReversePickup)}</b>} /> */}

        </DataTable>
      </div>
    </Col>
    <Col lg={6} md={6} className="mb-2 mt-3 align-items-center">
      <div className="d-flex gap-2">
        <div className="flex-fill">
          <b className="header mb-2">Part replacement</b>
          <div className="card ps-0 pe-0" id="table-border">
            <DataTable value={values.faultySystemAvailableList} showGridlines>
              {[
                { field: 'isReplace', label: 'Replaced', isDate: false },
                { field: 'partReplacedDate', label: 'Replaced Date', isDate: true, dependency: 'isReplace' },
              ].map(({ field, label, isDate, dependency }: any) => (
                <Column
                  key={field}
                  header={label}
                  headerClassName="headerjobsheet"
                  body={(rowData, options) => {
                    const index = options.rowIndex;
                    const { isSendFromMel, isDelivered } = rowData;
                    const isDisabledByDependency =
                      (field === 'isDelivered' && (!isSendFromMel || isFranchiseUser)) ||
                      (field === 'isReplace' && !isDelivered) ||
                      (isJobView == true && jobStatus.includes(values.status));

                    if (!isDate) {
                      return (
                        <div className='d-flex justify-content-center'>
                          <CheckboxInput
                            name={`faultySystemAvailableList[${index}].${field}`}
                            label=""
                            {...rest}
                            onChange={(e: any) => {
                              if (e.checked) {
                                if (field === 'isReplace' && reversePickupCourier?.includes(values?.faultySystemAvailableList[index]?.courierName)) {
                                  let localReversePickup = false;
                                  confirmDialog({
                                    header: <div>Confirmation {label}</div>,
                                    message: (isExchange ? <ReversePickupDialogContent onChange={(val) => (localReversePickup = val)} /> : <p>Are you sure you want to change <strong>Replaced</strong>?</p>),
                                    icon: 'pi pi-exclamation-triangle',
                                    accept: () => {
                                      handleChange(e);
                                      setFieldValue('isAutoReversePickupTrue', localReversePickup);
                                      setFieldValue(`faultySystemAvailableList[${index}].isAutoReversePickup`, localReversePickup);
                                      dispatch(updateNeedReversePickupLoading(id, rowData.outgoingDispatchId, rowData.label, field, "", "", localReversePickup));
                                    },
                                  });
                                  return;
                                }
                                confirmDialog({
                                  header: `Confirmation ${label}`,
                                  message: <p>Are you sure you want to mark <strong>{rowData.awbNumber}</strong> as <strong>{label}</strong>?</p>,
                                  icon: 'pi pi-exclamation-triangle',
                                  acceptClassName: 'p-button-danger',
                                  accept: () => {
                                    handleChange(e);
                                    dispatch(updateFaultySystemLoading(id, rowData.outgoingDispatchId, rowData.label, field));
                                  },
                                });
                              } else {
                                handleChange(e);
                              }
                            }}
                            onBlur={handleBlur}
                            value={rowData[field]}
                            required={false}
                            disabled={rowData[field] || isDisabledByDependency || ((hasCustomerRoleHandler() || hasDealerRoleHandler()) ? disabledForDealer.includes(field) : false)}
                          />
                          <ErrorMessage name={`faultySystemAvailableList[${index}].${field}`} component={ErrorText} />
                        </div>
                      );
                    } else {
                      const dateValue = rowData[field] != "" ? formatDateTimeFormServerView(rowData[field], false) : 'N/A';
                      return (
                        <div className="d-flex align-items-center justify-content-center gap-2">
                          <span>{dateValue}</span>
                        </div>
                      );
                    }
                  }}
                />
              ))}
            </DataTable>
          </div>
        </div>

        <div>
          <b className="header mb-2">Auto Reverse Pickup</b>
          <div className="card ps-0 pe-0" id="table-border">
            <DataTable value={values.faultySystemAvailableList} showGridlines>
              <Column
                header="Auto Reverse Pickup"
                headerClassName="headerjobsheet"
                body={(rowData) => (
                  <div className='d-flex justify-content-center'>
                    {statusBodyTemplate(rowData.isAutoReversePickup)}
                  </div>
                )}
              />
            </DataTable>
          </div>
        </div>

        <div className="flex-fill">
          <b className="header d-block" style={{ visibility: "hidden" }}>&nbsp;</b>
          <div className="card ps-0 pe-0" id="table-border">
            <DataTable value={values.faultySystemAvailableList} showGridlines>
              <Column
                header="Faulty System Available"
                headerClassName="headerjobsheet"
                body={(rowData, options) => {
                  const index = options.rowIndex;
                  const field = 'isFaultySystem';
                  const label = 'Faulty System Available';
                  const { isReplace } = rowData;
                  const isDisabledByDependency = (!isReplace || isFranchiseUser) || (isJobView == true && jobStatus.includes(values.status));

                  return (
                    <div className='d-flex justify-content-center'>
                      <CheckboxInput
                        name={`faultySystemAvailableList[${index}].${field}`}
                        label=""
                        {...rest}
                        onChange={(e: any) => {
                          if (e.checked) {
                            confirmDialog({
                              header: `Confirmation ${label}`,
                              message: <p>Are you sure you want to mark <strong>{rowData.awbNumber}</strong> as <strong>{label}</strong>?</p>,
                              icon: 'pi pi-exclamation-triangle',
                              acceptClassName: 'p-button-danger',
                              accept: () => {
                                handleChange(e);
                                dispatch(updateFaultySystemLoading(id, rowData.outgoingDispatchId, rowData.label, field));
                              },
                            });
                          } else {
                            handleChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                        value={rowData[field]}
                        required={false}
                        disabled={rowData[field] || isDisabledByDependency || ((hasCustomerRoleHandler() || hasDealerRoleHandler()) ? disabledForDealer.includes(field) : false)}
                      />
                      <ErrorMessage name={`faultySystemAvailableList[${index}].${field}`} component={ErrorText} />
                    </div>
                  );
                }}
              />
            </DataTable>
          </div>
        </div>
      </div>
    </Col>

    {values.incomingCourierTrackingList?.length > 0 && (
      <Col lg={12} md={12} className="mb-2 mt-3 align-items-center">
        <b className="header mb-2">Incoming Courier Tracking</b>
        <div className="card ps-0 pe-0" id="table-border">
          <DataTable value={values.incomingCourierTrackingList} showGridlines>
            <Column
              field="courierName"
              header="Courier"
              body={(rowData) => (
                <b>
                  {rowData.deliveryType == "Hand Carry"
                    ? "Hand Carry"
                    : rowData.courierName == "Other"
                      ? rowData.courierNameIndividual
                      : rowData.courierName}
                </b>
              )}
            />
            <Column
              field="awbNumber"
              header="Way Bill No."
              body={(rowData) => <b>{rowData.awbNumber}</b>}
            />
            <Column field="label" header="Dispatch Number" body={(rowData) => <b>{rowData.label}</b>} />

            {[
              { field: "isPartPicked", label: "Courier Pickup Done", isDate: false },
              {
                field: "partPickedDate",
                label: "Courier Pickup Date",
                isDate: true,
                dependency: "isPartPicked",
              },
              { field: "isPartReachedMout", label: "Part Reached MEL", isDate: false },
              {
                field: "partReachedMoutDate",
                label: "Part Reached MEL Date",
                isDate: true,
                dependency: "isPartReachedMout",
              },
            ].map(({ field, label, isDate, dependency }) => (
              <Column
                key={field}
                header={label}
                headerClassName="headerjobsheet"
                body={(rowData, options) => {
                  const index = options.rowIndex;
                  const { isPartPicked } = rowData;
                  const isDisabledByDependency =
                    (field === "isPartReachedMout" && (!isPartPicked || isFranchiseUser)) ||
                    (isJobView == true && jobStatus.includes(values.status));

                  if (!isDate) {
                    return (
                      <div className="d-flex justify-content-center">
                        <CheckboxInput
                          name={`incomingCourierTrackingList[${index}].${field}`}
                          label=""
                          {...rest}
                          onChange={(e: any) => {
                            if (e.checked) {
                              confirmDialog({
                                header: `Confirmation ${label}`,
                                message: (
                                  <div>
                                    <p>
                                      Are you sure you want to mark{" "}
                                      <strong>{rowData.label || rowData.awbNumber}</strong> as{" "}
                                      <strong>{label}</strong>?
                                    </p>
                                  </div>
                                ),
                                icon: "pi pi-exclamation-triangle",
                                acceptClassName: "p-button-danger",
                                accept: () => {
                                  handleChange(e);
                                  dispatch(
                                    updateIncomingDispatchTrackingLoading(
                                      id,
                                      rowData.incomingDispatchId,
                                      rowData.label,
                                      field
                                    )
                                  );
                                },
                              });
                            } else {
                              handleChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                          value={rowData[field]}
                          required={false}
                          disabled={
                            rowData[field] ||
                            isDisabledByDependency ||
                            (hasCustomerRoleHandler() || hasDealerRoleHandler()
                              ? disabledForDealer.includes(field)
                              : false)
                          }
                        />
                        <ErrorMessage
                          name={`incomingCourierTrackingList[${index}].${field}`}
                          component={ErrorText}
                        />
                      </div>
                    );
                  } else {
                    const dateValue =
                      rowData[field] && rowData[field] !== ""
                        ? formatDateTimeFormServerView(rowData[field], false)
                        : "N/A";

                    return (
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <span>{dateValue}</span>
                      </div>
                    );
                  }
                }}
              />
            ))}
          </DataTable>
        </div>
      </Col>
    )}

  </Row>
  )
}

export default FaultySystem;